import { Component } from '@angular/core';
import { IonicPage, NavParams, AlertController, ModalController, Platform, NavController, ToastController } from 'ionic-angular';
import { EmailComposer } from '@ionic-native/email-composer';
import { FileProvider } from '../../providers/file/file';
import { DomSanitizer } from '@angular/platform-browser';
import { StorageProvider } from '../../providers/storage/storage';
import { TranslateService } from '@ngx-translate/core';
import { AssetProvider } from '../../providers/asset/asset';
import { Asset } from 'interfaces/asset.model';
import { EmailPackageProvider } from '../../providers/email-package/email-package';
import { EmailPackagePage } from '../email-package/email-package';
import { EmailPackage } from 'interfaces/email-package.model';
import { AssetFile } from 'interfaces/asset-file.model';
import { VisitPackageModalPage, ModalData } from '../../pages/visit-package-modal/visit-package-modal';
import { HelperProvider } from '../../providers/helper/helper';
import { SocialSharing } from '@ionic-native/social-sharing';

@IonicPage()
@Component({
  selector: 'page-viewer-asset',
  templateUrl: 'viewer-asset.html',
})
export class ViewerAssetPage {
  asset: Asset;
  assetPaths: AssetFile;
  assetType: string;
  assetZipPath: string;
  isIosPlatform: boolean;
  win: any = window;

  constructor(
    public plt: Platform,
    public navParams: NavParams,
    private emailComposer: EmailComposer,
    private socialSharing: SocialSharing,
    public fileService: FileProvider,
    public alertCtrl: AlertController,
    private toastCtrl: ToastController,
    public sanitizer: DomSanitizer,
    private storageService: StorageProvider,
    public assetService: AssetProvider,
    public translate: TranslateService,
    public modalCtrl: ModalController,
    public emailPackageService: EmailPackageProvider,
    public helperService: HelperProvider,
    public navCtrl: NavController) 
  {
    this.asset = navParams.get("asset");
    this.assetPaths = navParams.get("assetPaths");
    this.assetType = navParams.get("assetType");
    // this.isIosPlatform = this.plt.is('ios');
    //[VP - 27/01/2021] Use custom function to detect iOS because of ionic bug: https://github.com/ionic-team/ionic-v3/issues/1104
    this.isIosPlatform = this.helperService.isIOS();
  }

  showEmailPackageModal(){
    this.emailPackageService.getPackages().then((emailPackages:EmailPackage[]) => {
      let emailPackageModal = this.modalCtrl.create(VisitPackageModalPage, { asset: this.asset, emailpackages: emailPackages });
      emailPackageModal.onDidDismiss((data: ModalData) => {
        if(data) {
          if (data.finish) {
            this.addPackageAndFinish(data);
          }
          else {
            this.addPackageAndContinue(data);
          } 
        }
      });
      emailPackageModal.present();
    });
  }

  addPackageAndFinish(data: ModalData){
    if(data.isNew){
      this.emailPackageService.createPackage(data, this.asset.AssetId)
      .then(res => {
        this.helperService.setActivePage(EmailPackagePage);
        this.navCtrl.setRoot(EmailPackagePage, {
          email: data.email
        });
      })
      .catch(err => console.log("error to update storage"))
    } else {
      data.existingPackage.attachments.push(this.asset.AssetId);
      this.emailPackageService.updatePackage(data.existingPackage)
      .then(res => {
        this.helperService.setActivePage(EmailPackagePage);
        this.navCtrl.setRoot(EmailPackagePage, {
          email: data.existingPackage.email
        });
      })
      .catch(err => console.log("error to update storage"))
    }
  }

  addPackageAndContinue(data: ModalData){
    if(data.isNew){
      this.emailPackageService.createPackage(data, this.asset.AssetId)
      .then(res => {
        this.navCtrl.pop();
        this.translate.get(['EMAIL_PACKAGE.CREATE_PACKAGE_SUCCESS']).subscribe(text => {
          this.showToast(text["EMAIL_PACKAGE.CREATE_PACKAGE_SUCCESS"]);
        });
      })
      .catch(err => console.log("error to update storage"))
    } else {
      data.existingPackage.attachments.push(this.asset.AssetId);
      this.emailPackageService.updatePackage(data.existingPackage)
      .then(res => {
        this.navCtrl.pop();
        this.translate.get(['EMAIL_PACKAGE.UPDATE_PACKAGE_SUCCESS']).subscribe(text => {
          this.showToast(text["EMAIL_PACKAGE.UPDATE_PACKAGE_SUCCESS"]);
        });
      })
      .catch(err => console.log("error to update storage"))
    }
  }

  shareByMail() {
    this.fileService.isAllowedFileSize(this.assetPaths.AssetPath).then((res: boolean) => {
      if(res){
        this.saveUserShareAction();
        let email = {
          attachments: [
            this.assetPaths.AssetPath
          ]
        };
        this.emailComposer.open(email);
      } else {
        this.translate.get(['ERROR.FILE_TOO_BIG_TITLE','ERROR.FILE_TOO_BIG_TEXT']).subscribe(text => {
          let alert = this.alertCtrl.create({
            title: text["ERROR.FILE_TOO_BIG_TITLE"],
            message: text["ERROR.FILE_TOO_BIG_TEXT"],
            buttons: ['OK']
          });
          alert.present();
        });
      }
    }, error => {
      console.log(error);
    });
  }

  share(event: MouseEvent) {
    this.fileService.isAllowedFileSize(this.assetPaths.AssetPath).then((res: boolean) => {
      if(res){
        this.saveUserShareAction();

        var options = {
          //message: '', // not supported on some apps (Facebook, Instagram)
          files: [this.assetPaths.AssetPath], // an array of filenames either locally or remotely
          iPadCoordinates: event.x+','+(event.y+30)+',0,0' //IOS only iPadCoordinates for where the popover should be point.  Format with x,y,width,height
        };
        
        this.socialSharing.shareWithOptions(options).then((result) => {
          console.log("Share completed? " + result.completed);
          console.log("Shared to app: " + result.app); // On iOS it's empty when sharing is cancelled (result.completed=false)
        }).catch((msg) => {
          console.log("Sharing failed with message: " + msg);
        });
      } else {
        this.translate.get(['ERROR.FILE_TOO_BIG_TITLE','ERROR.FILE_TOO_BIG_TEXT']).subscribe(text => {
          let alert = this.alertCtrl.create({
            title: text["ERROR.FILE_TOO_BIG_TITLE"],
            message: text["ERROR.FILE_TOO_BIG_TEXT"],
            buttons: ['OK']
          });
          alert.present();
        });
      }
    }, error => {
      console.log(error);
    });
  }

  safeUrl(url: string) {
    let safeUrl = "";
    if(this.isIosPlatform) {
      safeUrl = this.win.Ionic.WebView.convertFileSrc(url);
    } else {
      safeUrl = url;
    }
    return this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl);
  }

  saveUserShareAction(){
    this.storageService.setUserActions(this.asset.AssetId, StorageProvider.ACTION_SHARE);
  }
 
  downloadAssetFile(){
    this.assetService.getAssetFile(this.asset.AssetId)
    .subscribe((response: Blob) => {
      let fileData = response;
      this.downloadFile(fileData);
    });
  }

  downloadFile(data){
    const a = document.createElement("a");
    a.style.display = "none";
    document.body.appendChild(a);

    const blob = new Blob([data], { type: data.type });
    a.href= window.URL.createObjectURL(blob);
    a.setAttribute("download", this.asset.AssetName);
  
    // Trigger the download by simulating click
    a.click();

    // Cleanup
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }

  async showToast(msg) {
    const toast = await this.toastCtrl.create({
      message: msg,
      duration: 2000
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/viewer-asset/viewer-asset.ts